import React, { useEffect, useState } from 'react';
import MainMenu from '../../../components/menu/Menu';
import { useSelectedDevice } from '../../../store/devices/SelectedDevice';
import { Form, Layout } from 'antd';

import ArchiveResults from './components/ArchiveSearchPanel/components/ArchiveResults/ArchiveResults';
import ArchiveFilters from './components/ArchiveSearchPanel/components/ArchiveFilters/ArchiveFilters';
import { useArchiveSearch } from './components/ArchiveSearchPanel/helpers/hooks/useArchiveSearch';
import { FormFileFiltrationValues } from './components/ArchiveSearchPanel/components/ArchiveFilters/consts/consts';
import { useFilesStore } from '../../../store/devices/FilesDevicesFromDB';
import './styles.css';
import usePTTMessageStore from '../pttDispatcher/api/usePttMessageStore';
const { Header, Content } = Layout;

const Archive: React.FC = () => {
    const [currentMenuItem, setCurrentMenuItem] = useState('archive');
    const { selectedDevice } = useSelectedDevice();
    const archiveSearch = useArchiveSearch();
    const [form] = Form.useForm<FormFileFiltrationValues>();


    const test={a:1,b:2}
    const { fetchFiles, filesArchive, resetArchiveFiles } = useFilesStore();
    const { messagesArchive, clearArchiveMessages } = usePTTMessageStore();

    useEffect(() => {
        archiveSearch.fetchInitialData( );
        resetArchiveFiles();
        clearArchiveMessages();
    }, []);

    const handleMenuClick = (key: string) => {
        setCurrentMenuItem(key);
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>
            <Layout>
                <Content>
                    <div style={{ display: 'flex', height: 'calc(100vh - 64px)' }}>
                        {/* Sidebar — фильтры */}

                        <ArchiveFilters
                            form={form}
                            onFinish={archiveSearch.onSearch}
                            loading={archiveSearch.isSearching}
                            archiveSearch={archiveSearch}
                        />
                        {/* Main Content — результаты */}
                        <div className={'container-archive-result'}>
                            <span className={`headline small`}>
                                <div className="archive-main">
                                    <ArchiveResults
                                        // results={
                                        //     archiveSearch.contentType == 'files'
                                        //         ? filesArchive
                                        //         : messagesArchive
                                        // }
                                        selectedFiles={archiveSearch.selectedFiles}
                                        isSearching={archiveSearch.isSearching}
                                        contentType={archiveSearch.contentType}
                                        onFileClick={archiveSearch.handleFileClick}
                                        onCheckboxChange={archiveSearch.handleCheckboxChange}
                                        pagination={{
                                            current: archiveSearch.pagination.current,
                                            pageSize: archiveSearch.pagination.pageSize,
                                            total: archiveSearch.pagination.total || 0,
                                        }}
                                        onPageChange={archiveSearch.createHandlePageChange(form)}
                                    />
                                </div>
                            </span>
                        </div>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default Archive;
